function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

    if (summary.nextElementSibling.getAttribute("id")) {
        summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
        event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    if (summary.closest("header-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener("keydown", (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener("mousedown", (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        "focus",
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add("focused");
        },
        true
    );
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => video.pause());
    document.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: `application/${type}` },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceEl.classList.add("not-required");
            this.provinceEl.removeAttribute("required");
        } else {
            this.provinceEl.classList.remove("not-required");
            this.provinceEl.setAttribute("required", "required");
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }
        }
    },

    clearOptions: function (selector) {
        Array.from(selector.options).forEach((option) => !option.hasAttribute("disabled") && selector.removeChild(option));
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector("details");

        if (navigator.platform === "iPhone") document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

        this.addEventListener("keyup", this.onKeyUp.bind(this));
        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));
        this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
        this.querySelectorAll(".js-back-lv1").forEach((button) => button.addEventListener("click", this.onBackLevel1.bind(this)));
        this.querySelector(".js-close-drawer") && this.querySelector(".js-close-drawer").addEventListener("click", this.closeCustom.bind(this));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        const openDetailsElement = event.target.closest("details[open]");
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle
            ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
            : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest(".has-submenu");
        const isOpen = detailsElement.hasAttribute("open");
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
            summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            setTimeout(() => {
                detailsElement.classList.add("menu-opening");
                summaryElement.setAttribute("aria-expanded", true);
                parentMenuElement && parentMenuElement.classList.add("submenu-open");
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        });
        summaryElement.setAttribute("aria-expanded", true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove("menu-opening");
        this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
            details.removeAttribute("open");
            details.classList.remove("menu-opening");
        });
        this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
            submenu.classList.remove("submenu-open");
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest("details");
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest(".submenu-open");
        parentMenuElement && parentMenuElement.classList.remove("submenu-open");
        detailsElement.classList.remove("menu-opening");
        detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
        removeTrapFocus(detailsElement.querySelector("summary"));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute("open");
                if (detailsElement.closest("details[open]")) {
                    trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }

    onBackLevel1(event) {
        this.onCloseButtonClick(event);
        const accElement = event.target.closest(".accordion--content").querySelector(".js-accordion");
        accElement.click();
    }

    closeCustom(event) {
        const detailsElement = event.currentTarget.closest("details").querySelector("summary");
        detailsElement.click();
    }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById("shopify-section-header");
        this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
        document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        this.header.classList.add("menu-open");

        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        });

        summaryElement.setAttribute("aria-expanded", true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove("menu-open");
    }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
        this.addEventListener("keyup", (event) => {
            if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
        if (this.classList.contains("media-modal")) {
            this.addEventListener("pointerup", (event) => {
                if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
            });
        } else {
            this.addEventListener("click", (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden");
        this.setAttribute("open", "");
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove("overflow-hidden");
        document.body.dispatchEvent(new CustomEvent("modalClosed"));
        this.removeAttribute("open");
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector("button");

        if (!button) return;
        button.addEventListener("click", () => {
            const modal = document.querySelector(this.getAttribute("data-modal"));
            if (modal) modal.show(button);
        });
    }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener("click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute("loaded")) {
            const content = document.createElement("div");
            content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

            this.setAttribute("loaded", true);
            const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
            if (focus) deferredElement.focus();
        }
    }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector(".slider-counter--current");
        this.pageTotalElement = this.querySelector(".slider-counter--total");
        this.prevButton = this.querySelector('button[name="previous"]');
        this.dotsButtons = this.querySelectorAll("button.slider-counter__link--dots");
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener("scroll", this.update.bind(this));
        this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
        this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
        if (this.dotsButtons.length) {
            this.dotsButtons.forEach((element) => {
                element.addEventListener("click", this.onButtonClick.bind(this));
            });
        }
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(
                new CustomEvent("slideChanged", {
                    detail: {
                        currentPage: this.currentPage,
                        currentElement: this.sliderItemsToShow[this.currentPage - 1],
                    },
                })
            );
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute("disabled", "disabled");
        } else {
            this.prevButton.removeAttribute("disabled");
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute("disabled", "disabled");
        } else {
            this.nextButton.removeAttribute("disabled");
        }

        if (!this.dotsButtons.length) return;

        this.dotsButtons.forEach((link) => {
            link.classList.remove("slider-counter__link--active");
            link.removeAttribute("aria-current");
        });
        if (this.currentPage) {
            this.dotsButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
            this.dotsButtons[this.currentPage - 1].setAttribute("aria-current", true);
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
            event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
        if (!isNaN(parseInt(event.currentTarget.name))) {
            this.slideScrollPosition = parseInt(event.currentTarget.name) * this.sliderItemOffset;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition,
        });
    }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector(".slider-buttons");
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
        this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
        this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
        this.addEventListener("mouseover", this.focusInHandling.bind(this));
        this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
        this.addEventListener("focusin", this.focusInHandling.bind(this));
        this.addEventListener("focusout", this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) return;

        if (isFirstSlide && event.currentTarget.name === "previous") {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === "next") {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition,
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
        this.prevButton.removeAttribute("disabled");

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
            link.classList.remove("slider-counter__link--active");
            link.removeAttribute("aria-current");
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
        this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute("aria-live", "off");
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute("aria-live", "polite");
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
            this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
            this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition =
            this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const button = item.querySelector("a");
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute("tabindex");
                item.setAttribute("aria-hidden", "false");
                item.removeAttribute("tabindex");
            } else {
                if (button) button.setAttribute("tabindex", "-1");
                item.setAttribute("aria-hidden", "true");
                item.setAttribute("tabindex", "-1");
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition =
            this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(false, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        this.updateNotify();
        this.updateSKU();

        document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", this.currentVariant.price);
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
        if (!this.currentVariant) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }
    updateNotify() {
        const notify = document.getElementById(`notify-${this.dataset.section}`);
        if (notify) {
            notify.classList.toggle("hidden", this.currentVariant.available);
            notify.querySelector('[name="contact[variant_id]"]').value = this.currentVariant.id;
            notify.querySelector('[name="contact[email]"]').value = "";
            notify.querySelector(".BIS_response").textContent = "";
        }
    }
    updateSKU() {
        const sku = document.getElementById(`sku-${this.dataset.section}`);
        if (sku) {
            sku.classList.toggle("hidden", this.currentVariant.sku.length == 0);
            sku.querySelector(".sku-content").innerHTML = this.currentVariant.sku;
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector("pickup-availability");
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
        }
    }

    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        fetch(
            `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
                this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
        )
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                if (source && destination) destination.innerHTML = source.innerHTML;

                const destinationStock = document.getElementById(`stock-${this.dataset.section}`);
                const sourceStock = html.getElementById(`stock-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                if (sourceStock && destinationStock) destinationStock.innerHTML = sourceStock.innerHTML;

                const destinationAfterpay = document.querySelector(`afterpay-placement`);
                const sourceAfterpay = html.querySelector(`afterpay-placement`);
                if (sourceAfterpay && destinationAfterpay) destinationAfterpay.outerHTML = sourceAfterpay.outerHTML;

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove("visibility-hidden");
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;
        }
        document.getElementById("size-error") && (document.getElementById("size-error").innerHTML = "");
        addButton.setAttribute("nosize-selected", "selected");

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
        });
    }
}

customElements.define("variant-radios", VariantRadios);

class LoadMore extends HTMLElement {
    constructor() {
        super();
        /*
          .js-loadmore-link to get url
          .js-loadmore-append is element to append new data
          .js-loadmore-data is element to get new data form ajax
        */
    }

    connectedCallback() {
        this.linkGet = this.querySelector(".js-loadmore-link");
        this.linkGet.addEventListener("click", this.activeHandle.bind(this));
    }
    async activeHandle(e) {
        e.preventDefault();
        this.linkGet.classList.add("loading");
        let link = this.linkGet.href;
        try {
            let html = await this.getHtml(link);
            let htmlResponse = html.querySelector(".js-loadmore-data");
            let btnResponse = html.querySelector("load-more");
            document.querySelector(".js-loadmore-append").innerHTML += htmlResponse.innerHTML;
            this.outerHTML = btnResponse ? btnResponse.outerHTML : "";
        } catch (error) {
            console.error(error);
            this.linkGet.classList.remove("loading");
        }
    }
    getHtml(link) {
        return fetch(link)
            .then((r) => r.text())
            .then((text) => {
                return new DOMParser().parseFromString(text, "text/html");
            })
            .catch((e) => e);
    }
}

customElements.define("load-more", LoadMore);

class swiperSlider extends HTMLElement {
    constructor() {
        super();
        this.initSlide();
    }

    setOptions() {
        if (this.section == "brand-carousel") {
            this.options = {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 54,
                watchOverflow: true,
                centerInsufficientSlides: true,
                breakpoints: {
                    990: {
                        slidesPerView: 6,
                        spaceBetween: 107,
                    },
                },
            };
        }

        if (this.section == "category-carousel") {
            const itemLength = this.querySelectorAll(".swiper-slide").length;
            let loopSlide = false;
            let fakeSpace = 0;
            if (window.innerWidth > 990) {
                loopSlide = itemLength > 3 ? true : false;
                fakeSpace = loopSlide ? ((window.innerWidth - 24 * 2) / 6) * -1 : 0;
            } else if (window.innerWidth > 750) {
                loopSlide = itemLength > 2 ? true : false;
                fakeSpace = loopSlide ? ((window.innerWidth - 24) / 4) * -1 : 0;
            } else {
                // loopSlide = itemLength > 2 ? true : false;
                loopSlide = true;
            }

            this.options = {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 9,
                watchOverflow: true,
                // centerInsufficientSlides: true,
                centeredSlidesBounds: true,
                loop: loopSlide,
                breakpoints: {
                    750: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                        // centeredSlides: true,
                    },
                    990: {
                        slidesPerView: 3,
                    },
                },
            };
        }

        if (this.section == "trust-banner") {
            this.options = {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 12,
                watchOverflow: true,
                cssMode: true,
                centerInsufficientSlides: true,
                breakpoints: {
                    750: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    990: {
                        slidesPerView: 4,
                        spaceBetween: 32,
                    },
                },
            };
        }

        if (this.section == "trending-carousel") {
            this.options = {
                slidesPerView: 2.2,
                spaceBetween: 8,
                watchOverflow: true,
                centerInsufficientSlides: true,
                watchSlidesProgress: true,
                // cssMode: true,
                focusableElements: "input, select, option, textarea, button, video, label, form",
                breakpoints: {
                    750: {
                        slidesPerView: 3,
                    },
                    990: {
                        slidesPerView: Number(this.dataset.columns),
                        spaceBetween: 24,
                    },
                },
            };
        }

        if (this.section == "sir-carousel") {
            this.options = {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 9,
                autoHeight: true,
                watchOverflow: true,
                centerInsufficientSlides: true,
                watchSlidesProgress: true,
                focusableElements: "input, select, option, textarea, button, video, label, form",
                breakpoints: {
                    750: {
                        slidesPerGroup: 3,
                        slidesPerView: 3,
                    },
                    990: {
                        slidesPerGroup: Number(this.dataset.columns),
                        slidesPerView: Number(this.dataset.columns),
                        spaceBetween: 9,
                    },
                },
            };
        }

        if (this.section == "cart-drawer-collection") {
            this.options = {
                spaceBetween: 20,
                breakpoints: {
                    750: {
                        spaceBetween: 24,
                    },
                },
            };
        }

        if (this.section == "mega-menu") {
            this.options = {
                slidesPerView: "auto",
                spaceBetween: 24,
                watchOverflow: true,
                watchSlidesProgress: true,
                mousewheel: {
                    invert: false,
                },
                freeMode: {
                    enabled: true,
                    // sticky: true,
                },
                pagination: {
                    el: this.querySelector(".swiper-pagination"),
                    type: "progressbar",
                },
            };
        }
        if (this.section == "list-product") {
            this.options = {
                slidesPerView: 2.2,
                spaceBetween: 8,
                watchOverflow: true,
                breakpoints: {
                    750: {
                        slidesPerView: 1,
                        spaceBetween: 24,
                    },
                },
            };
        }
        if (this.section == "swatch-product") {
            this.options = {
                slidesPerView: "auto",
                spaceBetween: 1,
                watchOverflow: true,
                mousewheel: {
                    releaseOnEdges: true,
                },
                breakpoints: {
                    750: {
                        spaceBetween: 6,
                    },
                },
            };
        }

        if (this.nextBtn && this.prevBtn) {
            this.options.navigation = {
                nextEl: this.nextBtn,
                prevEl: this.prevBtn,
            };
        }

        if (this.pagination) {
            this.options.pagination = {
                el: this.pagination,
                clickable: true,
            };
        }
    }

    initSlide() {
        this.slider = this.querySelector(".js-slider");
        this.nextBtn = this.querySelector(".js-nav-right");
        this.prevBtn = this.querySelector(".js-nav-left");
        this.pagination = this.querySelector(".js-pagination");
        this.section = this.dataset.section;
        this.options = {};
        this.setOptions();
        this.swiperSlider = new Swiper(this.slider, this.options);
    }
}

customElements.define("swiper-slider", swiperSlider);

class Accordion extends HTMLElement {
    // add class active for ".js-accordion" and class opened for ".accordion--panel" want auto open
    constructor() {
        super();
    }

    connectedCallback() {
        const toggle = this.hasAttribute("toggle"); // has attribute toggle will close another tab if open this tab
        let listAcc = this.querySelectorAll(".js-accordion");

        listAcc.forEach((acc) => {
            acc.addEventListener("click", (e) => {
                if (e.target.nodeName === "A") return; // disable click event when clicking to <a></a> tag
                if (toggle) {
                    let open = acc.classList.contains("active") ? true : false;
                    listAcc.forEach((rmAcc) => {
                        rmAcc.classList.remove("active");
                        this.smallFunction(rmAcc);
                    });

                    if (!open) {
                        acc.classList.add("active");
                        this.smallFunction(acc);
                    }
                } else {
                    acc.classList.toggle("active");
                    this.smallFunction(acc);
                }
            });
        });
        this.querySelectorAll(".opened").forEach((opened) => (opened.style.maxHeight = opened.scrollHeight + "px"));
        window.addEventListener("resize", this.reSetHeight.bind(this));
    }

    smallFunction(elm) {
        let panel = elm.nextElementSibling;
        if (!elm.classList.contains("active")) {
            panel.style.maxHeight = null;
            panel.classList.remove("open", "opened");
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
            panel.classList.add("open");
        }
    }
    reSetHeight() {
        this.querySelectorAll(".open").forEach((i) => (i.style.maxHeight = i.scrollHeight + "px"));
    }
}

customElements.define("component-accordion", Accordion);
class HeroSwiper extends HTMLElement {
    constructor() {
        super();
        this.initVideo();
        this.initSlide();
    }

    initVideo() {
        this.querySelectorAll("[data-type='youtube']").forEach((elmIframe) => {
            const iframeId = elmIframe.getAttribute("data-mobile-id");
            if (iframeId) {
                if (window.matchMedia("(max-width: 749px)").matches) {
                    elmIframe.setAttribute("src", "");
                    elmIframe.setAttribute(
                        "src",
                        `https://www.youtube.com/embed/${iframeId}?enablejsapi=1&controls=0&rel=0&showinfo=0&autoplay=${
                            Number(elmIframe.dataset.index) == 1 ? "1" : "0"
                        }&mute=1&playsinline=1&playlist=${iframeId}&loop=1`
                    );
                }
            }
        });
        this.querySelectorAll("[data-type='vimeo']").forEach((elmIframe) => {
            const iframeId = elmIframe.getAttribute("data-mobile-id");
            if (iframeId) {
                if (window.matchMedia("(max-width: 749px)").matches) {
                    elmIframe.setAttribute(
                        "src",
                        `https://player.vimeo.com/video/${iframeId}?autoplay=${
                            Number(elmIframe.dataset.index) == 1 ? "1" : "0"
                        }&loop=1&muted=1&controls=0&title=0&byline=0&portrait=0&sidedock=0`
                    );
                }
            }
        });
    }

    initSlide() {
        if (this.querySelectorAll(".swiper-slide").length == 0) return;
        this.slider = this.querySelector(".swiper");
        this.options = {
            slidesPerView: 1,
            watchOverflow: true,
            allowTouchMove: false,
            effect: "fade",
            loop: this.querySelectorAll(".swiper-slide").length > 1,
            autoHeight: this.hasAttribute("data-height"),
            autoplay: this.hasAttribute("data-autoplay")
                ? {
                      delay: Number(this.dataset.autoplaySpeed),
                      disableOnInteraction: false,
                  }
                : false,
            on: {
                init: (e) => {
                    this.playPauseVideo(this.querySelector(".swiper-slide-active"), "play");
                },
                slideChange: (e) => {
                    this.playPauseVideo(e.slides[e.previousIndex], "pause");
                },
                slideChangeTransitionEnd: (e) => {
                    this.playPauseVideo(this.querySelector(".swiper-slide-active"), "play");
                },
            },
        };

        this.pagination = this.querySelector(".js-pagination");
        if (this.pagination) {
            this.options.pagination = {
                el: this.pagination,
                clickable: true,
            };
        }
        this.bannerSlider = new Swiper(this.slider, this.options);
    }

    postMessageToPlayer(player, command) {
        if (player == null || command == null) return;
        player.contentWindow.postMessage(JSON.stringify(command), "*");
    }

    // When the slide is changing
    playPauseVideo(currentElm, control) {
        const player = currentElm.querySelector("iframe") ? currentElm.querySelector("iframe") : null;
        const type = currentElm.getAttribute("data-slide-type");

        if (type === "vimeo") {
            let startTime = currentElm.querySelector("iframe").dataset.video_start;
            switch (control) {
                case "play":
                    if (startTime != null && startTime > 0) {
                        this.postMessageToPlayer(player, {
                            method: "setCurrentTime",
                            value: startTime,
                        });
                    }
                    this.postMessageToPlayer(player, {
                        method: "play",
                        value: 1,
                    });
                    break;
                case "pause":
                    this.postMessageToPlayer(player, {
                        method: "pause",
                        value: 1,
                    });
                    break;
            }
        } else if (type === "youtube") {
            switch (control) {
                case "play":
                    this.postMessageToPlayer(player, {
                        event: "command",
                        func: "mute",
                    });
                    this.postMessageToPlayer(player, {
                        event: "command",
                        func: "playVideo",
                    });
                    break;
                case "pause":
                    this.postMessageToPlayer(player, {
                        event: "command",
                        func: "pauseVideo",
                    });
                    break;
            }
        } else if (type === "source") {
            const videoDesktop = currentElm.querySelector(".js-video-desktop");
            const videoMobile = currentElm.querySelector(".js-video-mobile");
            let video;
            if (videoDesktop) {
                if (window.matchMedia("(min-width: 750px)").matches) video = videoDesktop;
                else if (videoMobile) video = videoMobile;
            }

            if (video) {
                if (control === "play") {
                    if (video.readyState != 4) {
                        video.load();
                        video.onloadeddata = () => video.play();
                    } else video.play();
                } else {
                    video.pause();
                }
            }
        }
    }
}

customElements.define("hero-swiper", HeroSwiper);
class CurrencyForm extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", this.currencyChange);
    }
    currencyChange() {
        const form = this.querySelector("form");
        form.submit();
    }
}

customElements.define("currency-form", CurrencyForm);
class WidgetWeather extends HTMLElement {
    constructor() {
        super();
        this.API = this.dataset.api;
        this.setListLocations(); // 1
        this.setElm(); // 2
    }
    setListLocations() {
        const removeDuplicate = (data) => data.filter((val, index) => data.indexOf(val) === index);
        let locations = this.dataset.locations
            .split(",") // to array
            .map((l) => l.trim()) // remove space around
            .map((l) => l.replace(/[^a-z0-9 ]/gi, "")) // remove non-alphanumeric characters
            .map((l) => l.toLowerCase()); // to lower case
        this.locationsRemoveDuplicate = removeDuplicate(locations);
    }
    async setElm() {
        const locations = await this.requestAPI();
        const main = this.querySelector(".swiper-wrapper");
        locations.forEach((location) => {
            if (location) {
                let html = `<div class="swiper-slide">
                    <div class="location-item">
                        <span class="location-name" title="${location.name}">${location.name}</span>
                        <span class="location-time js-location-time" data-location="${location.id}"></span>
                        <span class="location-temp">${Math.round(location.main.temp)}°C</span>
                    </div>
                </div>`;
                main.innerHTML += html;
                setInterval(() => {
                    this.querySelector(`.js-location-time[data-location="${location.id}"]`).innerHTML = moment()
                        .utcOffset(location.timezone / 60)
                        .format("H:mm");
                }, 1000);
            }
        });
        this.setSlide(); // 3
        setTimeout(() => this.classList.add("loaded"), 1001);
    }
    async requestAPI() {
        let listUrl = this.locationsRemoveDuplicate.map(
            (l) => `https://api.openweathermap.org/data/2.5/weather?q=${encodeURIComponent(l)}&appid=${this.API}&units=metric`
        );
        let request = await listUrl.map((url) => fetch(url));
        return await Promise.all(request)
            .then((responses) => Promise.all(responses.filter((r) => r.ok).map((r) => r.json())))
            .catch((e) => console.error(e));
    }
    setSlide() {
        this.slide = new Swiper(this.querySelector(".swiper"), {
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            allowTouchMove: false,
        });
    }
}

customElements.define("widget-weather", WidgetWeather);

class CardProduct extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.slideImage();
        if (this.closest(".card-product")) {
            this.closest(".card-product").addEventListener("mouseenter", this.inHover.bind(this));
            this.closest(".card-product").addEventListener("mouseleave", this.outHover.bind(this));
        }
        this.querySelectorAll("form").forEach((form) => form.addEventListener("submit", this.submitHandle.bind(this)));
        this.iWishlist();
    }
    iWishlist() {
        try {
            let elm = this.querySelector(".iWishAddColl");
            let variantId = elm.dataset.variant;
            let productId = elm.dataset.product;
            if (elm.classList.contains("iwishcheck")) {
                if (isInWishlist(productId, variantId)) {
                    elm.classList.add("iwishAdded");
                    elm.innerHTML = iwish_added_txt_col;
                } else {
                    elm.classList.remove("iwishAdded");
                    elm.innerHTML = iwish_add_txt_col;
                }
                elm.classList.remove("iwishcheck");
            }
        } catch (error) {}
    }

    submitHandle(event) {
        event.preventDefault();
        const form = event.target;
        const button = event.submitter;
        button.classList.add("loading");
        const formData = new FormData(form);
        let variantID = Number(button.dataset.variantId);
        formData.set("id", variantID);
        const cart = document.querySelector("cart-drawer") || document.querySelector("cart-items");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        if (cart) {
            formData.append(
                "sections",
                cart.getSectionsToRender().map((section) => section.section)
            );
            formData.append("sections_url", window.location.pathname);
            if (cart.hasOwnProperty("setActiveElement")) cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description, event);
                    this.error = true;
                    return;
                } else if (!cart) {
                    window.location = window.routes.cart_url;
                    return;
                }
                this.error = false;
                cart.renderContents(response);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                if (cart && cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
                if (!cart.dataset.timeout) {
                    cart.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                }
                button.classList.remove("loading");
            });
    }
    slideImage() {
        this.imagesElm = this.querySelector(".js-card-images");
        if (!this.imagesElm) return;
        let options = {
            cssMode: true,
            watchOverflow: true,
        };
        if (this.imagesElm.querySelector(".swiper-button-next") && this.imagesElm.querySelector(".swiper-button-prev")) {
            options.navigation = {
                nextEl: this.imagesElm.querySelector(".swiper-button-next"),
                prevEl: this.imagesElm.querySelector(".swiper-button-prev"),
            };
        }
        if (this.imagesElm.querySelectorAll(".swiper-slide").length > 1) options.loop = true;
        this.swiper = new Swiper(this.imagesElm, options);
    }
    inHover(e) {
        if (this.swiper && this.swiper.realIndex == 0 && window.matchMedia("(hover: hover)").matches) this.swiper.slideToLoop(1, 0);
    }
    outHover(e) {
        if (this.swiper && this.swiper.realIndex == 1 && window.matchMedia("(hover: hover)").matches) this.swiper.slideToLoop(0, 0);
    }
    handleErrorMessage(msg, event) {
        let elmEr = event.target.closest("form").querySelector(".card-product__error-msg");
        if (elmEr) {
            elmEr.textContent = msg;
            setTimeout(() => {
                elmEr.textContent = "";
            }, 2000);
        }
    }
}

customElements.define("card-product", CardProduct);

function getProvince(e, t) {
    // e = zip code
    // t = country
    if (
        "string" == typeof e &&
        ("Australia" === t || "United States" === t) &&
        !(("Australia" === t && 4 !== e.length) || ("United States" === t && 5 !== e.length))
    ) {
        let n,
            p,
            r = parseInt(e, 10);
        return (
            "Australia" === t
                ? (r >= 1e3 && r <= 2599) || (r >= 2620 && r <= 2899) || (r >= 2921 && r <= 2999)
                    ? ((n = "NSW"), (p = "New South Wales"))
                    : (r >= 200 && r <= 299) || (r >= 2600 && r <= 2619) || (r >= 2900 && r <= 2920)
                    ? ((n = "ACT"), (p = "Australian Capital Territory"))
                    : (r >= 3e3 && r <= 3999) || (r >= 8e3 && r <= 8999)
                    ? ((n = "VIC"), (p = "Victoria"))
                    : (r >= 4e3 && r <= 4999) || (r >= 9e3 && r <= 9999)
                    ? ((n = "QLD"), (p = "Queensland"))
                    : r >= 5e3 && r <= 5999
                    ? ((n = "SA"), (p = "South Australia"))
                    : (r >= 6e3 && r <= 6797) || (r >= 6800 && r <= 6999)
                    ? ((n = "WA"), (p = "Western Australia"))
                    : (r >= 7e3 && r <= 7799) || (r >= 7800 && r <= 7999)
                    ? ((n = "TAS"), (p = "Tasmania"))
                    : r >= 800 && r <= 999 && ((n = "NT"), (p = "Northern Territory"))
                : "United States" === t &&
                  (r >= 35e3 && r <= 36999
                      ? ((n = "AL"), (p = "Alabama"))
                      : r >= 99500 && r <= 99999
                      ? ((n = "AK"), (p = "Alaska"))
                      : r >= 85e3 && r <= 86999
                      ? ((n = "AZ"), (p = "Arizona"))
                      : r >= 71600 && r <= 72999
                      ? ((n = "AR"), (p = "Arkansas"))
                      : r >= 9e4 && r <= 96699
                      ? ((n = "CA"), (p = "California"))
                      : r >= 8e4 && r <= 81999
                      ? ((n = "CO"), (p = "Colorado"))
                      : r >= 6e3 && r <= 6999
                      ? ((n = "CT"), (p = "Connecticut"))
                      : r >= 19700 && r <= 19999
                      ? ((n = "DE"), (p = "Delaware"))
                      : r >= 32e3 && r <= 34999
                      ? ((n = "FL"), (p = "Florida"))
                      : r >= 3e4 && r <= 31999
                      ? ((n = "GA"), (p = "Georgia"))
                      : r >= 96700 && r <= 96999
                      ? ((n = "HI"), (p = "Hawaii"))
                      : r >= 83200 && r <= 83999
                      ? ((n = "ID"), (p = "Idaho"))
                      : r >= 6e4 && r <= 62999
                      ? ((n = "IL"), (p = "Illinois"))
                      : r >= 46e3 && r <= 47999
                      ? ((n = "IN"), (p = "Indiana"))
                      : r >= 5e4 && r <= 52999
                      ? ((n = "IA"), (p = "Iowa"))
                      : r >= 66e3 && r <= 67999
                      ? ((n = "KS"), (p = "Kansas"))
                      : r >= 4e4 && r <= 42999
                      ? ((n = "KY"), (p = "Kentucky"))
                      : r >= 7e4 && r <= 71599
                      ? ((n = "LA"), (p = "Louisiana"))
                      : r >= 3900 && r <= 4999
                      ? ((n = "ME"), (p = "Maine"))
                      : r >= 20600 && r <= 21999
                      ? ((n = "MD"), (p = "Maryland"))
                      : r >= 1e3 && r <= 2799
                      ? ((n = "MA"), (p = "Massachusetts"))
                      : r >= 48e3 && r <= 49999
                      ? ((n = "MI"), (p = "Michigan"))
                      : r >= 55e3 && r <= 56999
                      ? ((n = "MN"), (p = "Minnesota"))
                      : r >= 38600 && r <= 39999
                      ? ((n = "MS"), (p = "Mississippi"))
                      : r >= 63e3 && r <= 65999
                      ? ((n = "MO"), (p = "Missouri"))
                      : r >= 59e3 && r <= 59999
                      ? ((n = "MT"), (p = "Montana"))
                      : r >= 27e3 && r <= 28999
                      ? ((n = "NC"), (p = "North Carolina"))
                      : r >= 58e3 && r <= 58999
                      ? ((n = "ND"), (p = "North Dakota"))
                      : r >= 68e3 && r <= 69999
                      ? ((n = "NE"), (p = "Nebraska"))
                      : r >= 88900 && r <= 89999
                      ? ((n = "NV"), (p = "Nevada"))
                      : r >= 3e3 && r <= 3899
                      ? ((n = "NH"), (p = "New Hampshire"))
                      : r >= 7e3 && r <= 8999
                      ? ((n = "NJ"), (p = "New Jersey"))
                      : r >= 87e3 && r <= 88499
                      ? ((n = "NM"), (p = "New Mexico"))
                      : r >= 1e4 && r <= 14999
                      ? ((n = "NY"), (p = "New York"))
                      : r >= 43e3 && r <= 45999
                      ? ((n = "OH"), (p = "Ohio"))
                      : r >= 73e3 && r <= 74999
                      ? ((n = "OK"), (p = "Oklahoma"))
                      : r >= 97e3 && r <= 97999
                      ? ((n = "OR"), (p = "Oregon"))
                      : r >= 15e3 && r <= 19699
                      ? ((n = "PA"), (p = "Pennsylvania"))
                      : r >= 300 && r <= 999
                      ? ((n = "PR"), (p = "Puerto Rico"))
                      : r >= 2800 && r <= 2999
                      ? ((n = "RI"), (p = "Rhode Island"))
                      : r >= 29e3 && r <= 29999
                      ? ((n = "SC"), (p = "South Carolina"))
                      : r >= 57e3 && r <= 57999
                      ? ((n = "SD"), (p = "South Dakota"))
                      : r >= 37e3 && r <= 38599
                      ? ((n = "TN"), (p = "Tennessee"))
                      : (r >= 75e3 && r <= 79999) || (r >= 88500 && r <= 88599)
                      ? ((n = "TX"), (p = "Texas"))
                      : r >= 84e3 && r <= 84999
                      ? ((n = "UT"), (p = "Utah"))
                      : r >= 5e3 && r <= 5999
                      ? ((n = "VT"), (p = "Vermont"))
                      : r >= 22e3 && r <= 24699
                      ? ((n = "VA"), (p = "Virgina"))
                      : r >= 2e4 && r <= 20599
                      ? ((n = "DC"), (p = "Washington DC"))
                      : r >= 98e3 && r <= 99499
                      ? ((n = "WA"), (p = "Washington"))
                      : r >= 24700 && r <= 26999
                      ? ((n = "WV"), (p = "West Virginia"))
                      : r >= 53e3 && r <= 54999
                      ? ((n = "WI"), (p = "Wisconsin"))
                      : r >= 82e3 && r <= 83199 && ((n = "WY"), (p = "Wyoming"))),
            [n, p]
        );
    }
}

$(document).ready(function () {
    $(".iWishAdd").click(function (event) {
        var vid = $('.main-product-form [name="id"]').val();
        if (document.getElementById("size-error")) {
            if (vid == "") {
                event.stopImmediatePropagation();
                document.getElementById("size-error").innerHTML = "Please select a size option";
            } else {
                document.getElementById("size-error").innerHTML = "";
                setTimeout(() => {
                    if (!document.querySelector(".react-side-draw").classList.contains("open")) document.querySelector(".iWishView").click();
                }, 500);
            }
        }
    });
});

class PaymentsMerge extends HTMLElement {
    constructor() {
        super();
        this.querySelector(".open-modal-merge").addEventListener("click", this.openModal.bind(this));
        this.querySelector(".close-modal-merge").addEventListener("click", this.closeModal.bind(this));
        this.modal = this.querySelector(".modal-merge");
    }
    openModal() {
        this.modal.classList.remove("hidden");
        let styleAfterpay = document.createElement("style");
        styleAfterpay.innerHTML = ".afterpay-link{position:absolute;top:0;left:0;z-index:2;width:100%;height:100%;}*{color:transparent;opacity:0;}";
        this.querySelector("afterpay-placement")?.shadowRoot.appendChild(styleAfterpay);
    }
    closeModal() {
        this.modal.classList.add("hidden");
    }
}

customElements.define("payments-merge", PaymentsMerge);
